import type { GestureFrame } from '../types';

export function shouldOpenInstrumentGate(gesture: GestureFrame): boolean {
  return (
    gesture.fingers.size > 0 ||
    gesture.taps.length > 0 ||
    gesture.doubleTaps.length > 0
  );
}
